module.exports = __webpack_public_path__ + "static/media/mem4.ce1fb4f7.jpg";